declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dataLayer: any[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    gtag: (...args: any[]) => void;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    clarity: (...args: any[]) => void;
  }
}

export function initAnalytics() {
  const gaId = import.meta.env.VITE_GA_TRACKING_ID;
  const clarityId = import.meta.env.VITE_CLARITY_TRACKING_ID;

  if (gaId) initGoogleAnalytics(gaId);
  if (clarityId) initClarity(clarityId);
}

function initGoogleAnalytics(id: string) {
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params, @typescript-eslint/no-explicit-any
    window.dataLayer.push(arguments as any);
  };
  window.gtag('js', new Date());
  window.gtag('config', id);
}

function initClarity(id: string) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (function (c: any, l: any, a: any, r: any, i: any, t?: any, y?: any) {
    c[a] =
      c[a] ||
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      function (...args: any[]) {
        (c[a].q = c[a].q || []).push(args);
      };
    t = l.createElement(r);
    t.async = 1;
    t.src = 'https://www.clarity.ms/tag/' + i;
    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, 'clarity', 'script', id);
}
